module.exports = __webpack_public_path__ + "static/img/shd6.83f8ea5.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/participationCenter/shd6.png
// module id = nUQL
// module chunks = 0